import {createStyles, keyframes} from '@mantine/core';
import React, {type ReactNode} from 'react';

const shimmerKeyframes = keyframes({
  '0%': {backgroundPosition: '200% 0'},
  '100%': {backgroundPosition: '-200% 0'},
});

const useLLMShimmerStyles = createStyles((theme, {fontSize}: {fontSize?: number}) => ({
  shimmerText: {
    animation: `${shimmerKeyframes} 4s linear infinite`,
    background: `linear-gradient(120deg, ${theme.colors.gray[7]} 0%, ${theme.colors.gray[6]} 20%, ${theme.colors.gray[4]} 40%, ${theme.colors.gray[6]} 60%, ${theme.colors.gray[7]} 80%) 0 0 / 200% 100%`,
    backgroundClip: 'text',
    backgroundSize: '200% 100%',
    color: 'transparent',
    display: 'inline-block',
    fontSize,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  iconContainer: {
    alignItems: 'center',
    display: 'inline-flex',
    flexShrink: 0,
    justifyContent: 'center',
    lineHeight: 0,
  },
}));

export function LLMShimmerText({
  children,
  fontSize,
  className,
  ...rest
}: {
  children: ReactNode;
  fontSize?: number;
} & React.HTMLAttributes<HTMLSpanElement>): JSX.Element {
  const {classes, cx} = useLLMShimmerStyles({fontSize});

  return (
    <span className={cx(classes.shimmerText, className)} {...rest}>
      {children}
    </span>
  );
}

/** Shared icon wrapper styles for tool rows that need opacity on the glyph container. */
export function useLLMShimmerIconContainerClassName(): string {
  // eslint-disable-next-line benchlint/no-multiple-use-styles -- pre-existing multiple createStyles hook calls in this file
  const {classes} = useLLMShimmerStyles({});
  return classes.iconContainer;
}
